/**
 * Premium Cart Drawer — Club de Camisetas
 * Botón flotante + panel lateral que muestra el carrito sin salir de la página.
 */
(function () {
  "use strict";

  var btn = document.getElementById("pc-cart-btn");
  var drawer = document.getElementById("pc-drawer");
  if (!btn || !drawer) return;

  var itemsEl = drawer.querySelector("[data-pc-items]");
  var emptyEl = drawer.querySelector("[data-pc-empty]");
  var footerEl = drawer.querySelector("[data-pc-footer]");
  var subtotalEl = drawer.querySelector("[data-pc-subtotal]");
  var countEl = btn.querySelector("[data-pc-count]");

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function" && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function renderItem(item, index) {
    var row = document.createElement("div");
    row.className = "pc-item";
    row.innerHTML =
      '<img class="pc-item__img" src="' + (item.image || "") + '" alt="' + item.product_title + '">' +
      '<div class="pc-item__info">' +
        '<p class="pc-item__title">' + item.product_title + "</p>" +
        (item.variant_title ? '<p class="pc-item__variant">' + item.variant_title + "</p>" : "") +
        '<div class="pc-item__row">' +
          '<div class="pc-item__qty">' +
            '<button type="button" data-pc-minus>&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-pc-plus>&plus;</button>' +
          '</div>' +
          '<span class="pc-item__price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="pc-item__remove" data-pc-remove>Quitar</button>' +
      '</div>';

    row.querySelector("[data-pc-plus]").addEventListener("click", function () {
      changeLine(index + 1, item.quantity + 1);
    });
    row.querySelector("[data-pc-minus]").addEventListener("click", function () {
      changeLine(index + 1, item.quantity - 1);
    });
    row.querySelector("[data-pc-remove]").addEventListener("click", function () {
      changeLine(index + 1, 0);
    });

    return row;
  }

  function renderCart(cart) {
    itemsEl.innerHTML = "";

    if (!cart.items.length) {
      itemsEl.appendChild(emptyEl);
      emptyEl.hidden = false;
      footerEl.hidden = true;
    } else {
      emptyEl.hidden = true;
      footerEl.hidden = false;
      cart.items.forEach(function (item, index) {
        itemsEl.appendChild(renderItem(item, index));
      });
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (cart.item_count > 0) {
      countEl.hidden = false;
      countEl.textContent = cart.item_count;
    } else {
      countEl.hidden = true;
    }
  }

  function fetchCart() {
    return fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch(function () {});
  }

  btn.addEventListener("click", function () {
    fetchCart();
    openDrawer();
  });

  drawer.querySelectorAll("[data-pc-close]").forEach(function (el) {
    el.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });

  document.addEventListener("cart:open-drawer", function () {
    fetchCart();
    openDrawer();
  });

  document.addEventListener("cart:updated", function () {
    fetchCart();
  });

  // Carga inicial: solo actualiza el contador, sin abrir el panel
  fetchCart();
})();